import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  PROFILE_PENDING_CHANGES_GUARD,
  ProfileBioPage,
  ProfileFocusPage,
  ProfileAboutYouPage
} from '@sondermind/features/provider-facing/provider-profile';

import { ProfileLicenseInsurancePage } from '@sondermind/member/pages/profile-license-insurance/profile-license-insurance.component';

import { ProfileApproachesPage } from '../../pages/profile-approaches/profile-approaches.component';
import { ProfileIdentityPage } from '../../pages/profile-identity/profile-identity.component';
import { ProfileSpecialtiesPage } from '../../pages/profile-specialties/profile-specialties.component';

import { ProfileAppComponent } from './profile-app.component';

const routes: Routes = [
  {
    path: '',
    data: { membershipExpanded: true },
    component: ProfileAppComponent,
    children: [
      { path: '', component: ProfileAboutYouPage, canDeactivate: [PROFILE_PENDING_CHANGES_GUARD] },
      { path: 'credentials', component: ProfileLicenseInsurancePage },
      { path: 'bio', component: ProfileBioPage, canDeactivate: [PROFILE_PENDING_CHANGES_GUARD] },
      { path: 'focus', component: ProfileFocusPage, canDeactivate: [PROFILE_PENDING_CHANGES_GUARD] },
      { path: 'specialties', component: ProfileSpecialtiesPage, canDeactivate: [PROFILE_PENDING_CHANGES_GUARD] },
      { path: 'approaches', component: ProfileApproachesPage, canDeactivate: [PROFILE_PENDING_CHANGES_GUARD] },
      { path: 'identity', component: ProfileIdentityPage, canDeactivate: [PROFILE_PENDING_CHANGES_GUARD] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
